import React, { useCallback, useEffect, useState } from 'react';
import { CssBaseline, MuiThemeProvider } from '@material-ui/core';
import Container from '@material-ui/core/Container';

import Header from './Header';
import Footer from './Footer';
import NavBar from './NavBar';
import Routes from 'views/layouts/Routes';
import Router from 'common/components/Router';
import DebugTools from 'common/components/DebugTools';
import NotificationProvider from 'common/components/NotificationProvider';
import ScrollToTop from 'common/components/ScrollToTop';
import { layout, theme } from 'styles';
import { runAuthCookieWatcher } from 'common/functions';
import SessionExpiredDialog from './SessionExpriedDialog';
import { unauthorizedObserver } from 'common/observers';
import { makeStyles } from '@material-ui/styles';

const App = () => {
    const useStyles = makeStyles({
        '@global': {
            '#b-acc-toolbarWrap div.b-acc_hide_wrapper': {
                height: '96px',
                display: 'flex',
                alignItems: 'center',
            },
            '#b-acc-toolbarWrap div.b-acc_hide_toolbar.b-acc-icon-medium': {
                top: 'unset',
            }
        },
    });
    const { main } = layout.makeMainContentStyles();
    useStyles();
    const [ showSessionModal, setStatusSessionModal ] = useState(false);
    const handleClose = useCallback(() => setStatusSessionModal(false), [ setStatusSessionModal, ]);

    useEffect(
        () => {
            const subscriber = (data: { error: boolean, code: number, }) => {
                data.error && setStatusSessionModal(true);
            };

            unauthorizedObserver.subscribe(subscriber);

            return () => unauthorizedObserver.unsubscribe(subscriber);
        },
        []
    );

    useEffect(
        () => {
            runAuthCookieWatcher((oldCookieValue, currentCookieValue) => {
                oldCookieValue !== currentCookieValue && setStatusSessionModal(true);
            });
        },
        []
    );

    return (
        <MuiThemeProvider theme={theme}>
            <DebugTools />
            <CssBaseline />
            <Router>
                <ScrollToTop />
                <NotificationProvider>
                    <Header />
                    <Container>
                        <NavBar />
                        <main className={main}>
                            <Routes />
                        </main>
                    </Container>
                    <Footer />
                </NotificationProvider>
                <SessionExpiredDialog open={showSessionModal}
                                      handleClose={handleClose} />
            </Router>
        </MuiThemeProvider>
    );
};

export default App;
